import React from 'react';

import Table from 'components/Table';
import Button from 'components/Button';
import Money from 'components/Money';
import ExternalLink from 'components/ExternalLink';

import timeIcon from './assets/time.svg';
import launchIcon from './assets/launch.svg';

import {formatDate} from 'utils/datetime';

import './styles.css';

const getUnemployedRow = employment => {
  return (
    <Table.Row key={employment.id}>
      <Table.Cell>N/A Unemployed</Table.Cell>
      <Table.Cell>-</Table.Cell>
      <Table.Cell>-</Table.Cell>
      <Table.Cell>-</Table.Cell>
      <Table.Cell>-</Table.Cell>
      <Table.Cell>{formatDate(employment.createdAt)}</Table.Cell>
      <Table.Cell>N/A</Table.Cell>

      <Table.Cell>
        <Button white className="verifyButton">
          <img className="timeIcon" src={timeIcon} alt="" />
          <div className="text">Verify </div>
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const getEmployedRow = employment => {
  return (
    <Table.Row key={employment.id}>
      <Table.Cell>{employment.name}</Table.Cell>
      <Table.Cell>{employment.title}</Table.Cell>
      <Table.Cell>
        <ExternalLink href={employment.website} targetBlank>
          <img src={launchIcon} alt="Launch Icon" />
        </ExternalLink>
      </Table.Cell>
      <Table.Cell>
        <Money amount={employment.salary} />
      </Table.Cell>
      <Table.Cell>{formatDate(employment.startDate)}</Table.Cell>
      <Table.Cell>{formatDate(employment.createdAt)}</Table.Cell>
      <Table.Cell>N/A</Table.Cell>

      <Table.Cell>
        <Button white className="verifyButton">
          <img className="timeIcon" src={timeIcon} alt="" />
          <div className="text">Verify </div>
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const EmploymentsTable = ({employments}) => {
  return (
    <div className="EmploymentsTable">
      <div className="header">Employment</div>
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Employer" />
          <Table.HeaderItem heading="Title" />
          <Table.HeaderItem heading="Website" />
          <Table.HeaderItem heading="Salary" />
          <Table.HeaderItem heading="Start date" />
          <Table.HeaderItem heading="Submitted" />
          <Table.HeaderItem heading="Last verified" />
          <Table.HeaderItem />
        </Table.Header>
        <Table.Body>
          {employments &&
            employments.map(employment => {
              if (employment.unemployed) {
                return getUnemployedRow(employment);
              }
              return getEmployedRow(employment);
            })}
        </Table.Body>
      </Table>
      <div className="horizontalLine" />
    </div>
  );
};

export default EmploymentsTable;
